export default "__VITE_ASSET__Czw4kTx2__"